import moment from "moment";
import { post } from "venuescanner-js/services/api";
import controllers from "venuescanner-js/services/controllers";
import persistToStore from "./persistToStore";
import { popup } from "venuescanner-js/vanilla/components/popup";
import { reportError } from "venuescanner-js/react/services/errorService";
import { Flavour, venueFinderFlavours } from "./constants";
import { trackVenueFinder } from "venuescanner-js/react/tracking/track_event";

export default ({
    setLoading,
    nextStage,
    useStages = true,
    numberOfStages,
    base = "",
    onCompletion = () => {},
    flavour,
    conciergeCard,
  }) =>
  async (vals) => {
    setLoading(true);
    persistToStore(vals);

    conciergeCard
      ? window.ga_buffer?.send("Concierge_form", "Submit", "")
      : window.ga_buffer?.send(flavour, "enquiry_sent", "");

    const {
      location,
      eventType,
      guests,
      layout,
      budget,
      radiusInMiles,
      eventDescription,
      userName,
      userEmail,
      userPhone,
      userCompany,
      catering,
      newsletter,
      isCorporate,
      virtualEvents,
      isMultipleEvents,
      isFlexible,
      styles,
    } = vals;

    const { value: locationSlug } = location;
    const { value: tagSlug } = eventType;
    const [budgetMin, budgetMax] = budget;

    const { isCorporate: eventIsCorporate } = eventType;
    const eventIsPrivate = !eventIsCorporate;

    const shouldRedirectToSrp =
      flavour === Flavour.VENUE_SEARCH ||
      (venueFinderFlavours.includes(flavour) && eventIsPrivate);
    const shouldSendEmail =
      flavour === Flavour.CONCIERGE ||
      (venueFinderFlavours.includes(flavour) && eventIsCorporate);
    // console.log(Object.keys(vals))
    const params = {
      start_date:
        vals.start_date && moment(vals.start_date).format("DD/MM/YYYY"),
      end_date: vals.end_date && moment(vals.end_date).format("DD/MM/YYYY"),
      start_time: vals.start_time,
      end_time: vals.end_time,
      budget_min: budgetMin,
      budget_max: budgetMax,
      capacity: guests,
      radius_in_miles: radiusInMiles?.value,
      event_description: eventDescription,
      layout,
      style: styles && styles.length > 0 ? styles.join(",") : undefined,
    };

    const eventParams = {
      flavour,
      catering,
      user_name: userName,
      user_email: userEmail,
      user_phone: userPhone,
      user_company: userCompany,
      create_marketing_event: newsletter,
      event_type: eventType.value,
      query: location.label,
      location: {
        radius: parseFloat(radiusInMiles?.value, 10),
      },
      capacity: guests,
      price: {
        from: budgetMin,
        to: budgetMax,
      },
      date: {
        isFlexible,
        day: {
          from: params.start_date,
          to: params.end_date,
        },
        hours: {
          from: params.start_time,
          to: params.end_time,
        },
      },
      layout: {
        [layout]: true,
      },
      description: eventDescription,
      corporate: isCorporate,
      multiple_per_year: isMultipleEvents,
      virtual_events: virtualEvents,
      styles,
    };
    controllers.forms.venueFinder.post(eventParams);
    // await postToApi('venue-finder', eventParams)
    if (shouldSendEmail) {
      try {
        await post(base + "/venue-finder", eventParams);
        trackVenueFinder({
          eventType: eventParams.event_type,
          organiserType: eventParams.corporate
            ? "corporate"
            : "private individual",
          budget: `${eventParams.price.from} - ${eventParams.price.to}`,
          capacity: eventParams.capacity,
        });
      } catch (err) {
        reportError("venue-search", err);
        popup.show(
          "There was an error submitting your information. Our developers have been notified. In the meantime, please try again, or contact us.",
          { closable: true }
        );
        console.error(err);
      }
    }
    const goToSRP = ({ windowName = null } = {}) => {
      if (useStages) {
        // Disable the history listener and rewind back to the first page,
        // so if the goes back they will be on the first page, and navigating
        // forwards will go back to the SRP, not the last stage in the form
        delete window.onpopstate;
        window.skipPopstate = true;
        window.history.go(2 - numberOfStages);
      }

      const qs = Object.entries(params)
        .reduce((acc, [k, v]) => {
          if (typeof v !== "undefined") acc.append(k, v);
          return acc;
        }, new window.URLSearchParams())
        .toString();

      let srpUrl = `${
        window.location.href.match(/localhost/)
          ? ""
          : "https://www.venuescanner.com"
      }/book-venue-${locationSlug}/${tagSlug}`;
      if (qs.length > 0) srpUrl += "?" + qs.toString();
      if (windowName) {
        window.open(srpUrl, windowName);
      } else {
        window.location.assign(srpUrl);
      }
    };
    // if (!shouldRedirectToSrp) {
    const isCorpie = !shouldRedirectToSrp;
    setLoading(false);
    if (nextStage) nextStage();
    onCompletion(goToSRP, isCorpie);

    // }
    // if (useStages) {
    //   // Disable the history listener and rewind back to the first page,
    //   // so if the goes back they will be on the first page, and navigating
    //   // forwards will go back to the SRP, not the last stage in the form
    //   delete window.onpopstate
    //   window.skipPopstate = true
    //   window.history.go(2 - numberOfStages)
    // }

    // goToSRP()
  };
